/**
 * @file
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-2 RFC 9110 2 Conformance}
 */

import { Equal, numberEqual, objectEqual } from "@redotech/util/equal";

/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-2.5 RFC 9110 2.5 Protocol Version}
 */
export class ProtocolVersion {
  constructor(
    readonly major: number,
    readonly minor: number,
  ) {}

  toString() {
    return `${this.major}.${this.minor}`;
  }

  static readonly equal: Equal<ProtocolVersion> = objectEqual({
    major: numberEqual,
    minor: numberEqual,
  });
}
